import React from 'react';
import { useRevealChildren } from '../../hooks/useRevealChildren';
import PageHero from '../../components/PageHero/PageHero';
import Footer from '../../components/Footer/Footer';
import ContactForm from './ContactForm';
import ContactInfo from './ContactInfo';
import './ContactUs.css';

function ContactUs() {
  const ref = useRevealChildren();

  return (
    <>
      <PageHero title="Contact Us" subtitle="We'd love to hear from you" />
      <section className="contact-section" ref={ref}>
        <div className="container">
          <div className="contact-layout">
            <ContactForm />
            <ContactInfo />
          </div>
          <ContactMap />
        </div>
      </section>
      <Footer />
    </>
  );
}

function ContactMap() {
  return (
    <div className="contact-map reveal">
      <iframe
        title="STUPA Office Location"
        src="https://maps.google.com/maps?q=B-231+Greater+Kailash+Part+1+New+Delhi+110048&t=&z=15&ie=UTF8&iwloc=&output=embed"
        width="100%"
        height="350"
        style={{ border: 0, borderRadius: '20px' }}
        allowFullScreen
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
      />
    </div>
  );
}

export default ContactUs;
